import { Component } from '@angular/core';
import { CivicsComponent } from '../civics/civics.component';
import { SegurosPfComponent } from '../seguros-pf/seguros-pf.component';
import { CommonModule } from '@angular/common';
import { LoggerService } from '../../core/services/logger.service';
import { PessoaJuridicaComponent } from '../pessoa-juridica/pessoa-juridica.component';
import { NpcComponent } from '../npc/npc.component';
import { CorretoraComponent } from '../corretora/corretora.component';
import { PessoaFisicaComponent } from '../pessoa-fisica/pessoa-fisica.component';
import { GerentePfComponent } from '../gerente-pf/gerente-pf.component';
import { ItauShopComponent } from '../itau-shop/itau-shop.component';
import { IdpCallBackComponent } from '../idp-callback/idp-callback.component';
import { CivicsV2Component } from '../civics-v2/civics-v2.component';
import { ConsultoresSegurosPfComponent } from '../consultores-seguros-pf/consultores-seguros-pf.component';
import { RedePjComponent } from '../rede-pj/rede-pj.component';
import { IbbaComponent } from '../ibba/ibba.component';
import { RecuperacaoComponent } from '../recuperacao/recuperacao.component';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { OuvidoriaComponent } from '../ouvidoria/ouvidoria.component';
@Component({
  selector: 'app-logged',
  standalone: true,
  imports: [
    CommonModule,
    CivicsComponent,
    CivicsV2Component,
    SegurosPfComponent,
    PessoaJuridicaComponent,
    CorretoraComponent,
    PessoaFisicaComponent,
    NpcComponent,
    GerentePfComponent,
    ItauShopComponent,
    IdpCallBackComponent,
    RedePjComponent,
    ConsultoresSegurosPfComponent,
    IbbaComponent,
    RecuperacaoComponent,
    OuvidoriaComponent,
  ],
  templateUrl: './logged.component.html',
  styleUrl: './logged.component.css',
})
export class LoggedComponent {
  centralId: string | null = '';

  constructor(
    private logger: LoggerService,
    private localStorageUtils: LocalStorageUtils,
  ) {}

  ngOnInit() {
    this.centralId = this.localStorageUtils.safeGetItem('centralId');
    this.logger.info('LOGGED - inicializado | Central ID:', this.centralId);
  }
}
